import { render, staticRenderFns } from "./DeviceTable.vue?vue&type=template&id=9c96bfec&scoped=true&"
import script from "./DeviceTable.vue?vue&type=script&lang=js&"
export * from "./DeviceTable.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTable.vue?vue&type=style&index=0&id=9c96bfec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c96bfec",
  null
  
)

export default component.exports